import(/* webpackMode: "eager" */ "/vercel/path0/src/app/changelog/page.js");
